import { SettingConst } from '../../types';

/**
 * Follow-up to the previous Sales Hub XP for flash sales power users
 * https:www.notion.so/faire/Sale-Hub-Recommendation-12-16-15e2efb5c25a806b8035f4dd48d41826
 */
export const SALES_HUB_POWER_USERS_250116 =
  'SALES_HUB_POWER_USERS_250116' as SettingConst<
    'SALES_HUB_POWER_USERS_250116',
    boolean,
    'RETAILER' | 'HOTJAR_RETAILER'
  >;
